import React, {Component} from 'react';
import RjImg from "../../../static/assets/img/banner/banner_profile_img.png";
import ImgOverlay from "../../../static/assets/img/banner/overlay.png";
import { withTranslation } from 'react-i18next';

class Banner extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const {t} = this.props;
        return (
            <div className="bannerWrap">
                <div className="overlay"></div>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="bannerContent">
                                <h1 className="bannerHeading">{t('banner.headingFirst')} <br/>{t('banner.headingLast')}</h1>
                                <h2 className="bannerSubHeading">{t('banner.subHeading')}</h2>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 col-12">
                            <div className="bannerImg">
                                <div className="imgInneter">
                                    <div className="rJimg">
                                        <img src={ImgOverlay} alt="imgOverlay" className="imgOverlay"/>
                                        <img src={RjImg} alt="RJ"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(Banner);